import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  isLoggedInObs$: Observable<boolean>;
  private isLoggedIn$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
    this.isLoggedInObs$ = this.isLoggedIn$.asObservable();
  }

  setLogInStatus(isLoggedIn: boolean): void {
    this.isLoggedIn$.next(isLoggedIn);
  }

  getLatestIsLoggedInValue(): boolean {
    return this.isLoggedIn$.getValue();
  }
}
